import React from "react";
import { Box, Typography } from "@mui/material";

const getValueColor = (category, isAlarmActive) => {
  if ((category === "SampleCondition" || category === "Device") && isAlarmActive) return "error.main";
  if (category === "Warning" && isAlarmActive) return "warning.main";
  return "text.primary";
};

// Compact, tightly-packed row variant of ModuleItem, used only by DiagnosticsList.
const DiagnosticItem = ({ displayName = "", value = "", unit = "", category, isAlarmActive, dataIsRecent = false }) => {
  if (!displayName) return null;

  const color = getValueColor(category, isAlarmActive);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, py: 0.25, px: 0.75 }} marginRight={1} borderRight={1} borderColor="divider" pr={1}>
      <Typography variant="body2" color={color} noWrap sx={{ flex: 1, minWidth: 0, lineHeight: 1.2 }}>
        {displayName}
      </Typography>
      <Typography variant="body2" color={color} noWrap sx={{  lineHeight: 1.2, fontWeight: 300 }}>
        {dataIsRecent ? `${value} ${unit}` : "-"}
      </Typography>
    </Box>
  );
};

export default DiagnosticItem;
